import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Mission from './views/Mission.vue'
import Search from './views/Search.vue'
import Calendar from './views/Calendar.vue'
import Page from './views/Page.vue'
import Team from './views/Team.vue'
import Gallery from './views/Gallery.vue'
import Contact from './views/Contact.vue'
import News from './views/News.vue'
import Science from './views/Science.vue'
import Tech from './views/Tech.vue'
import Data from './views/Data.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/page',
      name: 'page',
      component: Page,
      props: true
    },
    {
      path: '/mission',
      name: 'mission',
      component: Mission
    },
    {
      path: '/data',
      name: 'data',
      component: Data
    },
    {
      path: '/tech',
      name: 'tech',
      component: Tech
    },
    {
      path: '/science',
      name: 'science',
      component: Science
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar
    },
    {
      path: '/team',
      name: 'team',
      component: Team
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {

    if (to.name === 'home') {
//      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
